<template>
  <div>
    <v-layout v-if="isLoading" column fill-height justify-center>
      <v-progress-circular indeterminate color="primary" :value="20"></v-progress-circular>
    </v-layout>
    <v-layout v-else column fill-height justify-center>
      <v-flex shrink>
        {{ title }}
      </v-flex>
      <v-flex shrink>
        <v-layout fill-height row wrap align-center>
          <v-flex>
            <v-layout column align-center>
              <v-flex class="display-2">
                {{ days }}
              </v-flex>
              <v-flex class="pt-0">
                Days
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>|</v-flex>
          <v-flex>
            <v-layout column align-center>
              <v-flex class="display-2">
                {{ hours }}
              </v-flex>
              <v-flex class="pt-0">
                Hours
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>|</v-flex>
          <v-flex>
            <v-layout column align-center>
              <v-flex class="display-2">
                {{ minutes }}
              </v-flex>
              <v-flex class="pt-0">
                Minutes
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import taskService from "../service";
import { mapGetters } from "vuex";
export default {
  props: ["self", "title"],
  data() {
    return {
      isLoading: true,
      days: 0,
      hours: 0,
      minutes: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"])
  },
  created() {
    if (this.self) {
      this.getTaskCompliteReport({ assignedToUserID: this.currentUser.userID });
    } else {
      this.getTaskCompliteReport();
    }
  },
  methods: {
    getTaskCompliteReport(data) {
      return taskService.taskCompliteReport(data).then(data => {
        console.log("dfasdf", data);
        this.days = data.data.averageTime.days | 0;
        this.hours = data.data.averageTime.hours | 0;
        this.minutes = data.data.averageTime.minutes | 0;
        this.isLoading = false
      });
    }
  }
};
</script>

<style scoped></style>
